import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, FileText, Settings, MessageCircle, HelpCircle, Gift, Folder, Zap, Moon, Rocket, ArrowRight } from 'lucide-react';
import SignupFormModal from '../components/SignupFormModal';

export default function DocumentationPage() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
    const [modalButtonType, setModalButtonType] = useState('demo');

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const documentationCards = [
        {
            Icon: FileText,
            title: "How Qorvix works",
            description: "Discover the 5-step system that powers instant AI response, smart follow ups, and automated scheduling 24/7",
            linkText: "Learn More",
            color: "bg-red-100",
            iconColor: "text-red-600"
        },
        {
            Icon: Settings,
            title: "Integrations",
            description: "Connect whatsapp, Gmail and hubspot, google Ads, and 20+ tools. Zero coding required",
            linkText: "View all",
            color: "bg-gray-100",
            iconColor: "text-gray-700"
        },
        {
            Icon: MessageCircle,
            title: "FAQs",
            description: "Get quick answers about setup pricing, security, multilingual support, and more",
            linkText: "See FAQs",
            color: "bg-orange-100",
            iconColor: "text-orange-600"
        },
        {
            Icon: HelpCircle,
            title: "Help Center",
            description: "access steup guides, troubleshooting, analytics tutorials , and 24/7 support options",
            linkText: "Get help",
            color: "bg-green-100",
            iconColor: "text-green-600"
        },
        {
            Icon: Gift,
            title: "Product Roadmap",
            description: "see what's: AI voice replies, predictive closing, and total autonomy mode in 2026",
            linkText: "View Roadmap",
            color: "bg-pink-100",
            iconColor: "text-pink-600"
        },
        {
            Icon: Folder,
            title: "AI & Develpoer Docs",
            description: "Build custom integrations and automate workflows with our developer-friendly API",
            linkText: "Contact Us",
            color: "bg-purple-100",
            iconColor: "text-purple-600"
        }
    ];

    const whyQorvix = [
        {
            Icon: Zap,
            title: "Every reply. Every second.Automated.",
            description: "Respond to every customer inquiry within 30 seconds, 24/7.",
            color: "text-yellow-500"
        },
        {
            Icon: Moon,
            title: "AI that sells while you sleep",
            description: "Never lose a lead to slow response times again.",
            color: "text-orange-500"
        },
        {
            Icon: Rocket,
            title: "From click to client — all automated",
            description: "Complete sales automation from first contact to closing.",
            color: "text-pink-500"
        }
    ];

    return (
        <div className="min-h-screen bg-white font-['Outfit',sans-serif] text-gray-900">
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');
        
        .text-gradient {
          background: linear-gradient(135deg, #FF6B35 0%, #FFA500 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      `}</style>

            {/* Navigation */}
            <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-white'}`}>
                <div className="max-w-7xl mx-auto px-6 lg:px-8">
                    <div className="flex justify-between items-center h-20">
                        <Link to="/" className="flex items-center gap-2">
                            <img
                                src="/logo-qorvix.png"
                                alt="Qorvix Logo"
                                className="h-10 w-auto"
                            />
                        </Link>
                        <div className="hidden lg:flex items-center space-x-8">
                            <Link to="/" className="text-gray-900 hover:text-orange-500 transition-colors font-medium text-[15px]">Home</Link>
                            <Link to="/about" className="text-gray-900 hover:text-orange-500 transition-colors font-medium text-[15px]">About</Link>
                            <Link to="/how-it-works" className="text-gray-900 hover:text-orange-500 transition-colors font-medium text-[15px]">How it works</Link>
                            <Link to="/portfolio" className="text-gray-900 hover:text-orange-500 transition-colors font-medium text-[15px]">Portfolio</Link>
                            <div className="relative group">
                                <button className="text-gray-900 hover:text-orange-500 transition-colors font-medium text-[15px] flex items-center gap-1">
                                    Resources
                                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                                        <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                                <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-xl border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                                    <div className="py-2">
                                        <Link to="/documentation" className="block px-4 py-2.5 text-orange-500 bg-gray-50 transition-colors">Documentation</Link>
                                        <Link to="/integrations" className="block px-4 py-2.5 text-gray-700 hover:bg-gray-50 hover:text-orange-500 transition-colors">Integration</Link>
                                        <Link to="/faq" className="block px-4 py-2.5 text-gray-700 hover:bg-gray-50 hover:text-orange-500 transition-colors">FAQs</Link>
                                        <a href="/help-center" className="block px-4 py-2.5 text-gray-700 hover:bg-gray-50 hover:text-orange-500 transition-colors">Help center</a>
                                        <Link to="/roadmap" className="block px-4 py-2.5 text-gray-700 hover:bg-gray-50 hover:text-orange-500 transition-colors">Roadmap</Link>
                                    </div>
                                </div>
                            </div>
                            <Link to="/contact" className="text-gray-900 hover:text-orange-500 transition-colors font-medium text-[15px]">Contact us</Link>
                            <button onClick={() => {
                                setModalButtonType('demo');
                                setIsSignupModalOpen(true);
                            }} className="bg-transparent border-2 border-orange-500 text-orange-500 px-6 py-2.5 rounded-lg hover:bg-orange-500 hover:text-white transition-all font-medium text-[15px]">
                                Start Free Demo
                            </button>
                        </div>

                        <button
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                            className="lg:hidden text-gray-900"
                        >
                            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
                        </button>
                    </div>
                </div>
            </nav>

            {/* Mobile Menu Modal - Add this after </nav> */}
            {mobileMenuOpen && (
                <div className="fixed inset-0 z-50 lg:hidden">
                    {/* Backdrop */}
                    <div className="fixed inset-0 bg-black/50" onClick={() => setMobileMenuOpen(false)}></div>

                    {/* Menu Panel */}
                    <div className="fixed top-8 left-1/2 -translate-x-1/2 w-[90%] max-w-sm bg-white rounded-3xl shadow-2xl p-8 z-50">
                        {/* Close Button */}
                        <button
                            onClick={() => setMobileMenuOpen(false)}
                            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
                        >
                            <X size={24} />
                        </button>

                        {/* Menu Items */}
                        <nav className="mt-4 space-y-6">
                            <Link
                                to="/"
                                className="block text-lg font-medium text-gray-900 hover:text-orange-500 transition-colors"
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                Home
                            </Link>
                            <Link
                                to="/about"
                                className="block text-lg font-medium text-gray-900 hover:text-orange-500 transition-colors"
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                About
                            </Link>
                            <Link
                                to="/how-it-works"
                                className="block text-lg font-medium text-gray-900 hover:text-orange-500 transition-colors"
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                How it works
                            </Link>
                            <Link
                                to="/portfolio"
                                className="block text-lg font-medium text-gray-900 hover:text-orange-500 transition-colors"
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                portfolio
                            </Link>

                            {/* Resources Dropdown */}
                            <div>
                                <button className="w-full text-left text-lg font-medium text-gray-900 flex items-center gap-2">
                                    resources
                                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" className="mt-1">
                                        <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                                <div className="mt-4 ml-4 space-y-4">
                                    <Link
                                        to="/documentation"
                                        className="block text-base text-gray-700 hover:text-orange-500 transition-colors"
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        Documentation
                                    </Link>
                                    <Link
                                        to="/integrations"
                                        className="block text-base text-gray-700 hover:text-orange-500 transition-colors"
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        Integrations
                                    </Link>
                                    <Link
                                        to="/faq"
                                        className="block text-base text-gray-700 hover:text-orange-500 transition-colors"
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        FAQs
                                    </Link>
                                    <Link
                                        to="/help-center"
                                        className="block text-base text-gray-700 hover:text-orange-500 transition-colors"
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        Help center
                                    </Link>
                                    <Link
                                        to="/roadmap"
                                        className="block text-base text-gray-700 hover:text-orange-500 transition-colors"
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        Roadmap
                                    </Link>
                                </div>
                            </div>

                            <Link
                                to="/contact"
                                className="block text-lg font-medium text-gray-900 hover:text-orange-500 transition-colors"
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                Contact us
                            </Link>

                            {/* CTA Button */}
                            <button onClick={() => {
                                setModalButtonType('demo');
                                setIsSignupModalOpen(true);
                            }} className="text-lg font-medium text-orange-500 border-b-2 border-orange-500 pb-1">
                                Start free demo
                            </button>
                        </nav>
                    </div>
                </div>
            )}
            {/* Hero Section */}
            <section className="pt-32 pb-32 px-4 bg-gradient-to-br from-orange-50 via-white to-orange-50">
                <div className="max-w-4xl mx-auto text-center">
                    <h1 className="text-5xl md:text-6xl font-bold mb-6">
                        <span className="text-gradient">QORVIX.AI</span><br />
                        Documentation
                    </h1>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
                        Qorvix is the fastest AI automation system built for real businesses — not tech talk. It answers every WhatsApp, email, or lead in under 30 seconds, talks like a real person, and never forgets to follow up.
                    </p>
                </div>
            </section>

            {/* What is Qorvix */}
            <section className="py-32 px-4 bg-white">
                <div className="max-w-4xl mx-auto text-center">
                    <h2 className="text-4xl md:text-5xl font-bold mb-6">
                        What Is <span className="text-gradient">Qorvix?</span>
                    </h2>
                    <p className="text-lg text-gray-600 leading-relaxed">
                        No missed leads. No manual work. Just constant results. We help car dealerships, real estate agents, service providers, and growing brands run their operations automatically — from the first message to the closed deal.
                    </p>
                </div>
            </section>

            {/* Explore Documentation */}
            <section className="py-32 px-4 bg-white">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-20">
                        <h2 className="text-4xl md:text-5xl font-bold mb-6">
                            Explore <span className="text-gradient">Documentation</span>
                        </h2>
                        <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                            No missed leads. No manual work. Just constant results. We help car dealerships, real estate agents, service providers, and growing brands run their operations automatically — from the first message to the closed deal.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
                        {documentationCards.map((card, index) => {
                            const IconComponent = card.Icon;
                            return (
                                <div key={index} className="bg-gray-50 p-12 rounded-2xl shadow-sm hover:shadow-lg transition-all text-center">
                                    <div className={`w-24 h-24 ${card.color} rounded-full flex items-center justify-center mx-auto mb-10`}>
                                        <IconComponent className={card.iconColor} size={36} strokeWidth={2} />
                                    </div>
                                    <h3 className="text-xl font-bold mb-6">{card.title}</h3>
                                    <p className="text-gray-600 text-sm mb-10 leading-relaxed min-h-[60px]">{card.description}</p>
                                    <button className="inline-flex items-center gap-2 text-gray-900 font-semibold hover:text-orange-500 transition-colors border-b-2 border-gray-900 hover:border-orange-500 pb-1">
                                        {card.linkText} <ArrowRight size={18} />
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* Why Qorvix */}
            <section className="py-20 px-4 bg-white">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl md:text-5xl font-bold mb-4">
                            Why <span className="text-gradient">Qorvix?</span>
                        </h2>
                        <p className="text-lg text-gray-600">
                            Building Toward Complete Business Automation
                        </p>
                    </div>

                    <div className="grid md:grid-cols-3 gap-8">
                        {whyQorvix.map((item, index) => {
                            const IconComponent = item.Icon;
                            return (
                                <div key={index} className="bg-gray-50 p-8 rounded-2xl text-center">
                                    <div className="w-16 h-16 mx-auto mb-6">
                                        <IconComponent className={item.color} size={64} strokeWidth={1.5} />
                                    </div>
                                    <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                                    <p className="text-gray-600">{item.description}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-20 px-4 relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-orange-400 via-orange-300 to-purple-400"></div>
                <div className="max-w-4xl mx-auto relative z-10">
                    <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-800">
                        Ready To Automate Your Business Operations?
                    </h2>
                    <p className="text-lg text-gray-700 mb-8">
                        Get Started With Qorvix In Under 5 Minutes. No Coding Required.F
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4">
                        <button onClick={() => {
                            setModalButtonType('demo');
                            setIsSignupModalOpen(true);
                        }} className="bg-orange-600 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-orange-700 transition-all">
                            Start free demo
                        </button>
                        <button className="border-2 border-white bg-white text-gray-800 px-8 py-3 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all">
                            view setup guide
                        </button>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-white py-12 px-4 border-t border-gray-200">
                <div className="max-w-7xl mx-auto">
                    <div className="grid md:grid-cols-4 gap-8 mb-8">
                        <div>
                            <h3 className="text-xl font-bold mb-4">
                                <span className="text-gradient">Qorvix</span> — Automate What Matters
                            </h3>
                            <p className="text-gray-600 text-sm leading-relaxed mb-6">
                                Qorvix helps businesses automate workflows, connect tools, and scale faster using AI-powered systems. From CRM integrations to WhatsApp automations — we build smart, no-code solutions that work.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-bold mb-4">Contact</h4>
                            <div className="space-y-2 text-sm text-gray-600">
                                <p>London, England, UK</p>
                                <p>+44 7757 233260</p>
                                <p>Support@qorvix.ai</p>
                            </div>
                        </div>

                        <div>
                            <h4 className="font-bold mb-4">Company</h4>
                            <div className="space-y-2 text-sm">
                                <Link to="/" className="block text-gray-600 hover:text-gray-900 transition-colors">Home</Link>
                                <Link to="/about" className="block text-gray-600 hover:text-gray-900 transition-colors">About</Link>
                                <Link to="/portfolio" className="block text-gray-600 hover:text-gray-900 transition-colors">Portfolio</Link>
                                <Link to="/contact" className="block text-gray-600 hover:text-gray-900 transition-colors">Contact</Link>
                                <Link to="/how-it-works" className="block text-gray-600 hover:text-gray-900 transition-colors">How it works</Link>
                            </div>
                        </div>

                        <div>
                            <h4 className="font-bold mb-4">Resources</h4>
                            <div className="space-y-2 text-sm">
                                <Link to="/documentation" className="block text-gray-600 hover:text-gray-900 transition-colors">Documentation</Link>
                                <Link to="/integrations" className="block text-gray-600 hover:text-gray-900 transition-colors">Integration</Link>
                                <Link to="/faq" className="block text-gray-600 hover:text-gray-900 transition-colors">FAQs</Link>
                                <a href="" className="block text-gray-600 hover:text-gray-900 transition-colors">Help Center</a>
                                <Link to="/roadmap" className="block text-gray-600 hover:text-gray-900 transition-colors">Roadmap</Link>
                            </div>
                        </div>
                    </div>

                    <div className="pt-8 flex items-center justify-between border-t border-gray-200">
                        <div className="text-2xl font-bold text-gradient">Qorvix</div>
                        <div className="text-sm text-gray-600">
                            © Qorvix Technologies. All Rights Reserved. Built with purpose and precision by <span className="font-semibold">Qorvix Team</span>.
                        </div>
                    </div>
                </div>
            </footer>
            {/* Signup Modal */}
            <SignupFormModal
                isOpen={isSignupModalOpen}
                onClose={() => setIsSignupModalOpen(false)}
                buttonType={modalButtonType}
            />
        </div>
    );
}